let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("3KV1Y"), load("kDPsc"), load("cQR04")]).then(() => parcelRequire('7EhPK'));